export default __webpack_public_path__ + "static/media/Animals-02.e5c2e977.png";